import React from 'react';
import Card from '../../../components/card';
import IconButton from '../../../components/iconButton';
import icons from '../../../assets/icons';
import './styles.scss';

const PortalCard = ({ portal, selectedPortal, onSelect, onPreview, canPreview }) => {
  const displayName = portal.displayName ? portal.displayName : '--';

  const company = portal.company.displayName ? portal.company.displayName : '--';

  return (
    <Card
      classes={selectedPortal && portal.id === selectedPortal.id ? 'selected' : ''}
      header={
        <div className="portal-card-header">
          <h3>{displayName}</h3>
          {canPreview && (
            <IconButton
              id={`preview-portal-${portal.id}`}
              icon="impersonateEye"
              btnClasses="small portal-preview-button"
              tooltip="Preview portal"
              onPress={event => {
                event.stopPropagation();
                onPreview(portal);
              }}
            />
          )}
        </div>
      }
      body={
        <div className="d-flex flex-column">
          <h4 id={`portal-owner-${portal.creator.email || '--'}`}>
            <b>Owner:</b> {portal.creator.email || '--'}
          </h4>
          <h4 id={`portal-company-${company}`}>
            <b>Company:</b> {company}
          </h4>
        </div>
      }
      footer={
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <img className={'blue-icon'} src={icons.projectOutline} alt="projects" />
            <h5>{`${portal?.campaignsCount === 0 ? 'No' : portal?.campaignsCount} ${portal?.campaignsCount > 1 || portal?.campaignsCount === 0 ? `campaigns` : `campaign`}`}</h5>
          </div>
        </div>
      }
      onPress={() => {
        onSelect(portal);
      }}
    />
  );
};

export default PortalCard;
